// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2abPZ","colMin":"styles_colMin__1P8JE"};